module.exports = __webpack_public_path__ + "img/panch_cuento_6.4d140861.png";